import { selector, selectorFamily } from 'recoil';
import { CARoleDetail } from './typing';
import { roleInfo, getReward } from '@/utils/api';
import { isMobile } from '@/utils/util';
import { activityId } from '@/App';

export const fetchRoleInfoState = selector<CARoleDetail>({
  key: 'fetchRoleInfoState',
  get: async ({ get }) => {
    const from_id = isMobile() ? '2' : '1';
    const [e, r] = await roleInfo<CARoleDetail>({
      from_id: from_id,
      activity_type: '3',
      aid: get(activityId),
    });
    if (r !== undefined) {
      return r.data;
    }
    if (e !== undefined) {
      throw new Error(e.data.msg as string);
    }
    throw new Error('数据异常');
  },
});

export const fetchReward = selectorFamily({
  key: 'fetchReward',
  get:
    (reward_bag_id) =>
    async ({ get }) => {
      const [e, r] = await getReward(
        {},
        {
          aid: get(activityId),
          reward_bag_id: reward_bag_id,
        }
      );
      if (r !== undefined) {
        return r;
      }
      if (e !== undefined) {
        throw e.data.msg;
      }
      throw new Error('数据异常');
    },
});
